module.exports = __webpack_public_path__ + "static/process_exporting6_2-948c0b1f2e7dbcfc8359ebfdf2d8b0b7.jpg";